import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Styles
import './mymessages.scss'

// Actions
import { getMyMessages } from '../../../actions/mypage'
import { triggerPopup } from '../../../actions/backdrop'

// Utils
import { renderFullDate } from '../../../utils/time'
import { translation } from '../../../utils/helpers'

// Components
import CleanModal from '../../../shared/modals/CleanModal'
import MyMessagesMessage from './Message'
import { hasSubscriptionPermission } from '../../../utils/auth'

// Elements
import Col from '../../../shared/elements/col'
// import Panel from '../../../shared/elements/panel'
// import Divider from '../../../shared/elements/divider'
// import LabelWrapper from '../../../shared/elements/labelWrapper'
import TableRow from '../../../shared/elements/tableRow'
import TableContainer from '../../../shared/elements/tableContainer'
import Grid from '../../../shared/elements/grid'
import PanelHeader from '../../../shared/elements/panelHeader'

class MyMessages extends Component {

  constructor (props) {
    super(props)
    this.state = {
      messages: [],
      openMessage: false
    }
    this.getMessages = this.getMessages.bind(this)
    this.renderMessage = this.renderMessage.bind(this)
  }

  componentDidMount () {
    this.getMessages()
  }

  getMessages () {
    this.props.getMyMessages(0).then((res) => {
      this.setState({
        messages: res.data
      })
    }, () => {
      window.toastr.error(translation('2002'), translation('216'))
    })
  }

  renderChild () {
    let child = ''
    if (this.props.children !== null) {
      child = React.cloneElement(this.props.children, {
        getMessages: this.getMessages
      })
    }
    return child
  }

  renderMessage (item, key) {
    // console.log('msg', item)
    const makeTime = () => {
      return renderFullDate(item.CreationDate, true)
    }
    const goToMessage = (e) => {
      if (window.innerWidth <= 760) {
        e.preventDefault()
        this.props.triggerPopup(true)
        this.setState({
          openMessage: item
        })
      }
    }
    return (
      <TableRow key={key}>
        <Link to={'/mypage/messages/' + item.Id} className='clearfix' onClick={goToMessage}>
          <Grid cols={['min-content', 1]}>
            <div className='left'>{!item.IsUserRead && <span />}</div>
            <div className='right'>
              <Grid>
                <span className='bold'>{item.SenderName}</span>
                <span className='bold'>{makeTime()}</span>
              </Grid>
              <div className='messageBody'>{item.Title}</div>
            </div>
          </Grid>
        </Link>
      </TableRow>
    )
  }

  renderMessagePopup () {
    const onClose = () => {
      this.props.triggerPopup(false)
      this.setState({
        openMessage: false
      })
    }
    return (
      <CleanModal show={this.state.openMessage !== false} header={translation('930')} onClose={onClose}>
        <MyMessagesMessage item={this.state.openMessage} />
      </CleanModal>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    return (
      <div className='row mymessages__screen'>
        <Col id='items'>
          {this.props.renderMenu()}
          <PanelHeader text={translation('1243')} />
          <TableContainer>
            {this.state.messages.map(this.renderMessage)}
            {this.state.messages.length === 0 && (
              <div style={{marginTop: 10}}>{translation('1244')}</div>
            )}
          </TableContainer>
        </Col>
        <Col id='message'>
          {this.renderChild()}
        </Col>
        {this.state.openMessage !== false && this.renderMessagePopup()}
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getMyMessages,
  triggerPopup
})(MyMessages)



// WEBPACK FOOTER //
// ./src/app/pages/MyPage/MyMessages/index.js